import { PageHeader } from "#components/page-header"
import { GeneralTab } from "#components/settings/general-tab"
import { InvitationTab } from "#components/settings/invitation-tab"
import { Card, CardContent } from "#components/ui/card"
import { InnerSideNav, type InnerSideNavItem } from "#components/ui/inner-side-nav"
import { useI18n } from "#hooks/use-i18n"
import { cardEntrance, slideUp } from "#lib/animations"
import { motion } from "framer-motion"
import { Database, Mail, Settings as SettingsIcon } from "lucide-react"
import { useState } from "react"

const Settings: React.FC = () => {
  const [activeTab, setActiveTab] = useState("general")
  const { t } = useI18n()

  const navItems: InnerSideNavItem[] = [
    {
      id: "general",
      title: t("pages.settings.tabs.general"),
      icon: SettingsIcon,
    },
    {
      id: "invitation",
      title: t("pages.settings.tabs.invitation"),
      icon: Mail,
    },
    {
      id: "data",
      title: t("pages.settings.tabs.data"),
      icon: Database,
    },
  ]

  const renderContent = () => {
    switch (activeTab) {
      case "general":
        return <GeneralTab />
      case "invitation":
        return <InvitationTab />
      case "data":
        return (
          <div className="flex flex-col items-center justify-center py-12 text-center">
            <p className="text-muted-foreground text-lg">{t("pages.settings.data.comingSoon")}</p>
            <p className="text-muted-foreground mt-2 text-sm">
              {t("pages.settings.data.description")}
            </p>
          </div>
        )
      default:
        return <GeneralTab />
    }
  }

  return (
    <div className="flex flex-1 flex-col gap-4 p-4 md:p-6">
      <motion.div initial="hidden" animate="visible" variants={slideUp} className="flex-shrink-0">
        <PageHeader title={t("pages.settings.title")} subtitle={t("pages.settings.subtitle")} />
      </motion.div>

      <div className="flex flex-col md:flex-row gap-6 items-start flex-1 min-h-0">
        <div className="flex-shrink-0 self-start">
          <InnerSideNav
            items={navItems}
            activeId={activeTab}
            onItemClick={setActiveTab}
            sheetTitle={t("pages.settings.sheetTitle")}
            sheetDescription={t("pages.settings.sheetDescription")}
          />
        </div>

        <motion.div
          initial="hidden"
          animate="visible"
          variants={cardEntrance}
          className="flex-1 min-w-0"
        >
          <Card>
            <CardContent className="p-6">{renderContent()}</CardContent>
          </Card>
        </motion.div>
      </div>
    </div>
  )
}

export default Settings
